function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.4375 19.5H5.25C5.7675 19.5 6.1875 19.08 6.1875 18.5625C6.1875 18.045 5.7675 17.625 5.25 17.625H2.4375V2.625H15.5625V18.5625C15.5625 19.08 15.9825 19.5 16.5 19.5C17.0175 19.5 17.4375 19.08 17.4375 18.5625V2.625C17.4375 1.59094 16.5966 0.75 15.5625 0.75H2.4375C1.40344 0.75 0.5625 1.59094 0.5625 2.625V17.625C0.5625 18.6591 1.40344 19.5 2.4375 19.5Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.17219 23.1788C8.52281 23.3231 8.92547 23.2434 9.19406 22.9753L10.4062 21.7636L11.6184 22.9753C11.798 23.1548 12.037 23.25 12.2812 23.25C12.4022 23.25 12.5241 23.2266 12.6403 23.1788C12.9905 23.0334 13.2188 22.6917 13.2188 22.3125V16.4939C13.5145 16.0013 13.6875 15.4275 13.6875 14.8125C13.6875 13.0031 12.2152 11.5312 10.4062 11.5312C8.59734 11.5312 7.125 13.0031 7.125 14.8125C7.125 15.4275 7.29844 16.0013 7.59375 16.4939V22.3125C7.59375 22.6917 7.82203 23.0334 8.17219 23.1788ZM9.46875 20.0522V17.9555C9.76594 18.0445 10.0805 18.0938 10.4062 18.0938C10.732 18.0938 11.0466 18.0445 11.3438 17.9555V20.0522C10.8117 19.5759 10.0008 19.5759 9.46875 20.0522ZM10.4062 13.4062C11.1816 13.4062 11.8125 14.0372 11.8125 14.8125C11.8125 15.5878 11.1816 16.2188 10.4062 16.2188C9.63094 16.2188 9 15.5878 9 14.8125C9 14.0372 9.63094 13.4062 10.4062 13.4062Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.75 7.3125C12.75 6.795 12.33 6.375 11.8125 6.375H6.1875C5.67 6.375 5.25 6.795 5.25 7.3125C5.25 7.83 5.67 8.25 6.1875 8.25H11.8125C12.33 8.25 12.75 7.83 12.75 7.3125Z",
  fill: "currentColor"
});

function SvgLicense(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicense);
export default __webpack_public_path__ + "static/media/license.953a9ab8.svg";
export { ForwardRef as ReactComponent };